// extracted by mini-css-extract-plugin
module.exports = {"content":"CylinderGroup_content__3n8g6","itemText":"CylinderGroup_itemText__3YwlE","pressure":"CylinderGroup_pressure__11UdU"};